import { ReactElement } from 'react';
import {
    UIModal,
    UIModalFooter,
    UIModalHeader,
    UIQRScanner,
    UISpacer,
    UIToast
} from '@/ui';
import { useDevicesTranslation } from '../hooks';

type ScanDeviceModalProps = {
    isOpen: boolean;
    onScannedDeviceId: (deviceId: string) => void;
    onClose: () => void;
};

export function ScanDeviceModal(props: ScanDeviceModalProps): ReactElement {
    const { isOpen, onClose } = props;

    return (
        <UIModal isOpen={isOpen} onClose={onClose}>
            {isOpen ? <FormContent {...props} /> : null}
        </UIModal>
    );
}

function FormContent(props: ScanDeviceModalProps): ReactElement {
    const { onScannedDeviceId, onClose } = props;
    const { t } = useDevicesTranslation();

    function handleScan(data: string) {
        // Data should look like this: https://device.safepointapp.com/?id=657867a46e14e074d4d38fa1
        let deviceId: string | null = null;

        function takeDeviceIdFromUrl(data: string): string | null {
            try {
                const url = new URL(data);
                return url.searchParams.get('id');
            } catch {
                return null;
            }
        }

        deviceId = takeDeviceIdFromUrl(data);

        if (deviceId) {
            onScannedDeviceId(deviceId);
            onClose();
            UIToast.success(t('components.scan_device_modal.scanned'));
        } else {
            UIToast.error(t('shared.errors.invalid_qr_code'));
        }
    }

    return (
        <>
            <UIModalHeader
                title={t('shared.labels.scan_qr_code')}
                subtitle={t('components.scan_device_modal.subtitle')}
            />
            <UISpacer />
            <UIQRScanner onScan={handleScan} />
            <UIModalFooter
                actions={[
                    {
                        text: t('shared.labels.close'),
                        onClick: () => {
                            onClose();
                        }
                    }
                ]}
            />
        </>
    );
}
